var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_vm._v("\n\t\tNot found\n\t")])
}
var staticRenderFns = []

export { render, staticRenderFns }